import QuestionEditorComponent from './components/QuestionEditorComponent.vue'
import { store, qEditorState } from './stores'
import { mathliveState } from './stores/mathlive'
import { store as bus_store } from '../../common/bus_store'
import i18n from '../client/i18n'
import Vuetify from 'vuetify'
import { IApplication } from '../../common/IApplication'

const app: IApplication = {
  elementId: 'question_editor',
  rootComponent: QuestionEditorComponent,
  stores: [
    {
      key: ['Editor'],
      module: store
    },
    {
      key: ['Bus'],
      module: bus_store
    }
  ],
  i18n,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi'
    }
  }),
  data: {
    dataStore: {
      qEditorState,
      mathliveState
    }
  }
}

export default app
